const DEBUG = false
const LIVE_ENDPOINT = 'https://bharatvideo.aicte-india.org/api/realtime/'
// const LIVE_ENDPOINT = "https://neo.futurixai.com"
const LOCALHOST_ENDPOINT = 'http://10.150.0.6:6969' // For testing
const endpoint = DEBUG ? LOCALHOST_ENDPOINT : LIVE_ENDPOINT
const outputLanguageOptions = [
    { label: 'Assamese ', value: 'as-IN', voice: 'as-IN-PriyomNeural' },
    { label: 'English', value: 'en-IN', voice: 'en-IN-PrabhatNeural' },
    { label: 'Hindi', value: 'hi-IN', voice: 'hi-IN-MadhurNeural' },
    { label: 'Telugu', value: 'te-IN', voice: 'te-IN-MohanNeural' },
    { label: 'Tamil', value: 'ta-IN', voice: 'ta-IN-ValluvarNeural' },
    { label: 'Kannada', value: 'kn-IN', voice: 'kn-IN-GaganNeural' },
    { label: 'Odia', value: 'or-IN', voice: 'or-IN-SukantNeural' },
    { label: 'Malayalam', value: 'ml-IN', voice: 'ml-IN-MidhunNeural' },
    { label: 'Marathi', value: 'mr-IN', voice: 'mr-IN-ManoharNeural' },
    { label: 'Gujarati', value: 'gu-IN', voice: 'gu-IN-NiranjanNeural' },
    { label: 'Bengali', value: 'bn-IN', voice: 'bn-IN-BashkarNeural' },
    { label: 'Urdu', value: 'ur-IN', voice: 'ur-IN-SalmanNeural' },
    { label: 'Punjabi ', value: 'pa-IN', voice: 'pa-IN-OjasNeural' },
]

export async function voiceToText(blob, targetLang) {
    console.log('Sending audio file to server for transcription...')
    console.log('Target Language: ' + targetLang)

    const formData = new FormData()
    formData.append('audio', blob)
    formData.set('language', targetLang)

    try {
        const payload = { method: 'POST', body: formData }
        const response = await fetch(`${endpoint}/transcribe`, payload)

        if (response.ok) {
            const result = await response.json()
            console.log('Transcription result:', result)

            return result
        } else {
            console.error('Server responded with status code:', response.status)
            const errorText = await response.text()
            console.error('Error message:', errorText)
            return null
        }
    } catch (error) {
        console.error('Error sending audio to server:', error)
        return null
    }
}

export async function combineAudioBlobs(audioBlobs) {
    const formData = new FormData()

    // Add each audio blob to the form data
    audioBlobs.forEach((blob, index) => {
        formData.append('audio_blobs[]', blob, `audio_${index}.mp3`)
    })

    try {
        const response = await fetch(`${endpoint}/combine-audio`, {
            method: 'POST',
            body: formData,
        })

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
        }
        const combinedAudioBlob = await response.blob()
        return combinedAudioBlob
    } catch (error) {
        console.error('Error combining audio blobs:', error)
    }
}

async function fetchToVoiceAPIWithPost(url, body, isJson = false) {
    console.log('Sending POST request to:', url)
    console.log('Body:', body)

    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }

    // Prepare URLSearchParams correctly
    const urlencoded = new URLSearchParams()
    for (const key in body) {
        if (body.hasOwnProperty(key)) {
            if (typeof body[key] === 'object') {
                console.log('Parsing JSON:', body[key])
                urlencoded.append(key, body[key])
            } else {
                urlencoded.append(key, body[key])
            }
        }
    }

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: urlencoded,
        })

        if (response.ok) {
            const result = await response.json()
            console.log('Response:', result)
            return result
        } else {
            const errorMsg = await response.text()
            throw new Error(`Status: ${response.status}, Message: ${errorMsg}`)
        }
    } catch (error) {
        console.error('Fetch error:', error.message)
        return null
    }
}

export async function translateText(text, outputLang) {
    if (!text) return ''
    const apiURL = 'https://voiceapi.aicte-india.org/text-to-text'
    const payload = { outputLang, text }
    const data = await fetchToVoiceAPIWithPost(apiURL, payload)
    const parsedData = data ? data.data : null
    return parsedData
}

export async function batchTranslate(texts, outputLang) {
    const translationPromises = texts.map(text =>
        translateText(text, outputLang),
    )

    try {
        const translatedTexts = await Promise.all(translationPromises)
        console.log('Translated texts:', translatedTexts)
        return translatedTexts
    } catch (error) {
        console.error('Error in translation:', error)
        return ''
    }
}

export async function synthesizeAudioForSegment(segment, targetLang, voice) {
    console.log('=== synthesizeAudioForSegment Debug ===')
    console.log('Input segment:', segment)
    console.log('Input targetLang:', targetLang)
    console.log('Input voice:', voice)

    // Find the correct voice for the targetLang if not provided
    let languageVoice
    if (!languageVoice) {
        const langObj = outputLanguageOptions.find(
            opt => opt.value === targetLang,
        )
        languageVoice = langObj ? langObj.voice : ''
        if (!languageVoice) {
            console.warn('No matching voice found for targetLang:', targetLang)
        }
    }
    console.log('Final languageVoice:', languageVoice)

    try {
        const requestBody = {
            text: segment,
            lang: targetLang,
            languageVoice: languageVoice,
            gender: 'male', // You may want to make this dynamic if needed
        }
        console.log('API request body:', requestBody)

        const response = await fetch(
            'https://anuvadini-services.aicte-india.org/api/text-to-speech',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer HoU01X4gxnOvstHn4KigjPgKqQ1JAA3E',
                },
                body: JSON.stringify(requestBody),
            },
        )

        console.log('API response status:', response.status)
        console.log('API response ok:', response.ok)
        console.log(
            'API response headers:',
            Object.fromEntries(response.headers.entries()),
        )

        if (!response.ok) {
            const errorText = await response.text()
            console.error('API error response:', errorText)
            throw new Error(
                `HTTP error! status: ${response.status}, message: ${errorText}`,
            )
        }

        const result = await response.json()
        console.log('API response result:', result)
        console.log('Result has audio field:', !!result.audio)
        console.log('Audio field type:', typeof result.audio)
        console.log('Audio field length:', result.audio?.length)

        if (!result.audio) {
            throw new Error('No audio field in response')
        }

        // The audio is base64-encoded, decode it
        let base64Audio = result.audio
        console.log('Original base64Audio length:', base64Audio.length)
        console.log(
            'Original base64Audio first 100 chars:',
            base64Audio.substring(0, 100),
        )

        // Use direct atob decoding - the API returns base64 data that should be used as-is
        // The leading // is part of the base64 data and should not be removed
        console.log('Using direct atob decoding')

        let byteCharacters
        try {
            byteCharacters = atob(base64Audio)
            console.log(
                'atob successful, byteCharacters length:',
                byteCharacters.length,
            )
        } catch (e) {
            console.error('atob failed for base64Audio:', base64Audio)
            console.error('atob error:', e)
            throw e
        }

        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        console.log('byteNumbers array created, length:', byteNumbers.length)

        const byteArray = new Uint8Array(byteNumbers)
        console.log('byteArray created, length:', byteArray.length)
        console.log('byteArray first 10 bytes:', byteArray.slice(0, 10))

        // Always use audio/mpeg for MP3 data since we know the API returns MP3
        const audioBlob = new Blob([byteArray], { type: 'audio/mpeg' })
        console.log('audioBlob created:', audioBlob)
        console.log('audioBlob size:', audioBlob.size)
        console.log('audioBlob type:', audioBlob.type)
        console.log('audioBlob valid:', audioBlob.size > 0)

        if (audioBlob.size === 0) {
            console.error('Created audioBlob is empty!')
            throw new Error('Created audio blob is empty')
        }

        console.log('=== synthesizeAudioForSegment Success ===')
        return audioBlob
    } catch (error) {
        console.error('Error in audio synthesis:', error)
        console.error('Error stack:', error.stack)
        return null
    }
}

export function playAudioBlob(audioData) {
    let blob
    if (audioData instanceof Blob) {
        blob = audioData
    } else if (
        audioData instanceof ArrayBuffer ||
        ArrayBuffer.isView(audioData)
    ) {
        blob = new Blob([audioData], { type: 'audio/mp3' })
    } else {
        console.error('Unsupported audio data type for playback:', audioData)
        return
    }
    const url = URL.createObjectURL(blob)
    const audio = new Audio(url)
    audio.onended = () => {
        URL.revokeObjectURL(url)
    }
    audio.onerror = e => {
        console.error('Audio playback error:', e, url, blob)
    }
    audio.play().catch(err => {
        console.error('audio.play() error:', err)
    })
}
